export default __webpack_public_path__ + "static/media/MercedesBenz.e7e14b2a.svg";